import { SectionTitles } from '@chiroup/core/enums/SectionTitles.enum';
import { QuestionAnswer } from '@chiroup/core/types/ComplaintSummary.type';
import { XCircle as XCircleIcon } from 'lucide-react';
import React from 'react';
import InteractiveValue from './InteractiveValue';

interface YellowFlagsDisplayProps {
  yellowFlags: string[];
  questionData: Record<string, any>;
  questionAnswerMaps: Record<string, QuestionAnswer>;
  isEditable: boolean;
  popoverOpen: Record<string, boolean>;
  onPopoverOpenChange: (questionId: string, open: boolean) => void;
  onAnswerChange: (questionId: string, newValue: string | string[], otherValue?: string) => void;
}

const YellowFlagsDisplay: React.FC<YellowFlagsDisplayProps> = ({
  yellowFlags,
  questionData,
  questionAnswerMaps,
  isEditable,
  popoverOpen,
  onPopoverOpenChange,
  onAnswerChange,
}) => {
  // Find the question ID for yellow flags (should be the only one in questionData)
  const yellowFlagsQuestionId = Object.keys(questionData)[0];
  const questionAnswerData = questionAnswerMaps[yellowFlagsQuestionId];

  // If no yellow flags, show "None" but still make it interactive
  const displayFlags = yellowFlags && yellowFlags.length > 0 ? yellowFlags : ['None'];

  // Safety check - if no questionAnswerData, create a default one
  const safeQuestionAnswerData = questionAnswerData || {
    options: [],
    selectedValues: [],
    questionType: 'checkbox',
    questionText: SectionTitles.YellowFlags,
  };

  return (
    <div className="rounded-md bg-yellow-50 p-4 mt-2">
      <div className="flex">
        <div className="shrink-0">
          <XCircleIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-yellow-800 mt-0">Yellow flags</h3>
          <div className="mt-2 text-sm text-yellow-700">
            <InteractiveValue
              questionId={yellowFlagsQuestionId}
              questionData={safeQuestionAnswerData}
              displayValue={displayFlags}
              isEditable={isEditable}
              popoverOpen={popoverOpen[yellowFlagsQuestionId] || false}
              onPopoverOpenChange={open => onPopoverOpenChange(yellowFlagsQuestionId, open)}
              onAnswerChange={onAnswerChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default YellowFlagsDisplay;
